import React, {useEffect, useRef, useState} from 'react';
import {Modal} from '@modules/common/modal';
import {Dropdown} from '@modules/common/dropdown/Dropdown';
import {Button} from '@components/elements/button';
import {LocalizedText} from '@components/elements/localizedText';
import styles from './styles.scss';
import {useTranslation} from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Slider from 'react-slick';
import classNames from 'classnames';
import {Input} from '@components/elements/input';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ru from 'react-phone-input-2/lang/ru.json';
import ua from './phoneLocalization/ua.json';
import {useSelector} from 'react-redux';
import config from '@config';
import {ApiActions, ApiConnector} from '@lib/api-connector';
import {toast} from 'react-hot-toast';

export const DemoAccess = () => {

    const pageData = useSelector((state:any) => state.pageData?.login) || {};
    const {data = {}} = pageData?.sections?.demoAccess || {};
    const {langCode = ''} = pageData;

    const [countryID, setCountryID] = useState(0);
    const [subjectID, setSubjectID] = useState(0);
    const [detailedInfoSubjectID, setDetailedInfoSubjectID] = useState(0);

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [showErrors, setShowErrors] = useState(false);

    const [requestStatus, setRequestStatus] = useState<'waiting'|'requested'|'success'>('waiting');

    const [agreementModalOpened, setAgreementModalOpened] = useState(false);
    const [agreementCountryID, setAgreementCountryID] = useState(0);

    const sliderRef = useRef(null);

    const {t} = useTranslation('login');

    const textContent:any = t('demoAccess', {returnObjects: true});

    useEffect(() => {
        if(data.countries.length == 1){
            //Если доступная для Демодоступа страна одна - то незачем давать выбор страны
            setCountryID(data.countries[0].id);
        }

        if(window.location.hostname == 'platform-amakids.eu'){
            //Clarity
            (function(c,l,a,r,i,t,y){
                // eslint-disable-next-line prefer-rest-params
                c[a] = c[a] || function(){(c[a].q = c[a].q || []).push(arguments);};
                t = l.createElement(r);t.async = 1;t.src = 'https://www.clarity.ms/tag/' + i;
                y = l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, 'clarity', 'script', 'qjxir5x3ww');
        }

    }, []);

    const avBackEndSubjectIDs = countryID > 0 ? data.countries.find(item => item.id == countryID)?.subjectIDs : [];//Доступные с бэка предметы
    const avFrontEndSubjectIDs = [9, 10, 11, 12, 13];//Доступные на фронте. Чтоб не крашилось, если с бэка дичь прийдет
    const avSubjectIDs = avBackEndSubjectIDs.filter(item => avFrontEndSubjectIDs.includes(item)) || [];//Объединяем с бэка и фронта

    const settings = {
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        className: styles.subjects,
        arrows: false,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    const openAgreement = () => {
        const link = pageData.agreements.find(country => country.id == agreementCountryID)?.link || null;
        if(link){
            window.open(link);
        }
    };

    const onSubjectModalClose = () => {
        if(data.countries.length == 1){
            location.href = config.path.login.main;
        }else{
            setCountryID(0);
        }
    };

    const onDetailedSubjectModalClose = () => setDetailedInfoSubjectID(0);
    const onCountryModalClose = () => location.href = config.path.login.main;

    const prevSlide = () => sliderRef.current.slickPrev();
    const nextSlide = () => sliderRef.current.slickNext();

    const isPhoneValid = () => {
        if(!phone || typeof phone != 'string'){
            return false;
        }
        return true;
    };

    const isNameValid = () => name.length >= 1;
    const isEmailValid = () => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

    const isFormValid = () => isPhoneValid() && isEmailValid() && isNameValid();

    const sendRequest = () => {
        if(requestStatus == 'waiting'){
            setShowErrors(true);
            if(!isFormValid()){
                return;
            }

            setRequestStatus('requested');

            const data = {
                action: ApiActions.demoAccessRequest,
                params: {countryID, subjectID, name, phone, email}
            };

            ApiConnector.request(data).then((response) => {
                if(response.status){
                    setRequestStatus('success');

                    // Отправка цели в гугл аналитику
                    try {
                        //@ts-ignore
                        gtag('event', 'отправка_формы_консультации_по_программа', {
                            'event_category': 'franchise',
                            'event_action': 'send_reuqest_form',
                        });
                    }catch (e) {}

                    if(['platform-smartum.com.ua'].indexOf(window.location.hostname) !== -1){
                        try {
                            //@ts-ignore
                            gtag('event', 'лид_ушел_на_платформу__actually_', {'event_category': 'conversion', 'event_action': 'request_form_send'});
                        }catch (e) {}
                    }
                }else{
                    toast.error(response?.data?.message || t('errors.server'));
                    setRequestStatus('waiting');
                }
            }).catch(() => {
                toast.error(t('errors.server'));
                setRequestStatus('waiting');
            });

        }
    };

    if(requestStatus == 'success'){
        return <div className={styles.successInfoWindow}>
            <img src={require('_assets/img/demoAccess/success.png')} alt="" />
            <div className={styles.title}>
                <LocalizedText path='login' name='success.title'/>
            </div>
            <div>
                <LocalizedText path='login' name='success.description'/>
            </div>
            <Button className={styles.button} onClick={() => location.href = config.path.login.main}>
                <LocalizedText path='login' name='buttons.ok'/>
            </Button>
        </div>;
    }

    return <div>

        <div className={styles.form}>
            <div className={styles.title}>
                <LocalizedText path='login' name='form.title'/>
            </div>
            <div className={styles.description}>
                <LocalizedText path='login' name='form.description'/>
            </div>
            <div className={styles.formElements}>
                <Input
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder={t('placeholders.name')}
                    error={showErrors && !isNameValid()}
                    errorText={t('errors.inputName')}
                />
                <div className={styles.phoneWrapper}>
                    <PhoneInput
                        key={langCode}
                        specialLabel={''}
                        placeholder={t('placeholders.phone')}
                        value={phone}
                        onChange={setPhone}
                        localization={langCode === 'ru' ? ru : langCode === 'ua' ? ua : {}}
                        containerClass={classNames(styles.phoneWrap, (showErrors && !isPhoneValid()) && styles.error)}
                        inputClass={styles.phoneInput}
                        buttonClass={styles.phoneButton}
                        dropdownClass={styles.phoneDropdown}
                    />

                    {showErrors && !isPhoneValid() && <div className={styles.errorText}>
                        {t('errors.inputPhone')}
                    </div>}
                </div>
                {/* <PhoneInput
                    placeholder={t('placeholders.phone')}
                    value={phone}
                    className={styles.phoneInput}
                    onChange={setPhone}
                    error={showErrors && !isPhoneValid()}
                    errorText={t('errors.inputPhone')}
                    inputComponent={Input}
                    labels={phoneLocale}
                    international

                /> */}
                <Input
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={t('placeholders.email')}
                    error={showErrors && !isEmailValid()}
                    errorText={t('errors.inputEmail')}
                />
                <Button className={styles.submitButton} onClick={sendRequest} disabled={requestStatus == 'requested'}>
                    <LocalizedText path='login' name='buttons.send'/>
                </Button>
            </div>

            <div className={styles.agreement}><LocalizedText path='login' name='agreement.firstPart'/><a onClick={() => setAgreementModalOpened(true)}><LocalizedText path='login' name='agreement.secondPart'/></a></div>
        </div>

        <Modal opened={countryID == 0} className={styles.countrySelectorModal} onClose={onCountryModalClose}>
            <div className={styles.content}>
                <div className={styles.title}>
                    <LocalizedText path='login' name='country.title'/>
                    <p className={styles.subtitle}><LocalizedText path='login' name='country.subtitle'/></p>
                </div>
                <Dropdown label={t('dropdown.label')} type='light' dropdownClassName={styles.countrySelector}>
                    <div className={styles.countries}>
                        {data.countries.map(country => <div className={styles.country} key={country.id} onClick={() => setCountryID(country.id)}>{country.title}</div>)}
                    </div>
                </Dropdown>
            </div>
        </Modal>

        <Modal opened={agreementModalOpened} className={styles.countrySelectorModal} onClose={() => setAgreementModalOpened(false)}>
            <div className={styles.content}>
                <div className={styles.title}>
                    <LocalizedText path='login' name='country.title'/>
                </div>
                <Dropdown label={pageData.agreements.find(country => country.id == agreementCountryID)?.title || t('dropdown.label')} type='light' dropdownClassName={styles.countrySelector}>
                    <div className={styles.countries}>
                        {pageData.agreements.map(country => <div className={styles.country} key={country.id} onClick={() => setAgreementCountryID(country.id)}>{country.title}</div>)}
                    </div>
                </Dropdown>
                {agreementCountryID > 0 && <Button onClick={openAgreement}>
                    <LocalizedText path='login' name='buttons.ok'/>
                </Button>}
            </div>
        </Modal>

        <Modal opened={countryID > 0 && subjectID == 0} className={styles.subjectSelectorModal} onClose={onSubjectModalClose}>

            <div className={styles.content}>
                <div className={styles.title}>
                    <LocalizedText path='login' name='title'/>
                </div>

                <div className={styles.sliderNavs}>
                    <img src={require('_assets/img/demoAccess/arrow-left.png')} alt="" onClick={prevSlide} className={styles.sliderNav}/>
                    <img src={require('_assets/img/demoAccess/arrow-left.png')} alt="" onClick={nextSlide} className={classNames(styles.sliderNav, styles.next)}/>
                </div>

                {avSubjectIDs.length >= 1 && <Slider {...settings} ref={sliderRef}>
                    {avSubjectIDs.map(subjectID => <div className={styles.subject} key={subjectID}>
                        <div className={styles.data} onClick={() => setSubjectID(subjectID)}>
                            <img src={require('_assets/img/demoAccess/subjects/' + subjectID + '/main.png')} alt=""/>
                            <div className={styles.title}>{textContent[subjectID].title}</div>
                            <div className={styles.description}>{textContent[subjectID].description}</div>
                        </div>
                        <div className={styles.toDetails} onClick={() => setDetailedInfoSubjectID(subjectID)}><LocalizedText path='login' name='learnMore'/> <img src={require('_assets/img/demoAccess/details-arrow.png')} alt=""/></div>
                    </div>)}
                </Slider>}
            </div>
        </Modal>

        {detailedInfoSubjectID > 0 && <Modal opened={countryID > 0 && detailedInfoSubjectID > 0 && subjectID == 0} className={styles.subjectSelectorModal} onClose={onDetailedSubjectModalClose}>

            <div className={styles.content}>
                <div className={styles.details}>
                    <div className={styles.info}>
                        <div className={styles.title}>{textContent[detailedInfoSubjectID].title}</div>
                        <div className={styles.description}>
                            <div>{textContent[detailedInfoSubjectID].text}</div>
                            <ul>
                                {textContent[detailedInfoSubjectID].advantages.map((item, index) => <li key={index}>{item}</li>)}
                            </ul>
                        </div>
                        <Button className={styles.getAccessButton} onClick={() => setSubjectID(detailedInfoSubjectID)}>
                            <LocalizedText path='login' name='buttons.getAccess'/>
                        </Button>
                    </div>
                    <div className={styles.images}>
                        <img src={require('_assets/img/demoAccess/subjects/' + detailedInfoSubjectID + '/details-big.png')} alt=""/>
                        <img src={require('_assets/img/demoAccess/subjects/' + detailedInfoSubjectID + '/details-small.png')} alt=""/>
                        <img src={require('_assets/img/demoAccess/subjects/' + detailedInfoSubjectID + '/details-small2.png')} alt=""/>
                    </div>
                </div>
            </div>
        </Modal>}
    </div>;
};